// Utility functions for safe DOM operations and error handling
export const safeQuerySelector = (selector, context = document) => {
  try {
    return context?.querySelector?.(selector) || null;
  } catch (error) {
    console.warn('Safe query selector failed:', error);
    return null;
  }
};

export const safeAddEventListener = (element, event, handler, options) => {
  if (element && typeof element.addEventListener === 'function') {
    try {
      element.addEventListener(event, handler, options);
      return true;
    } catch (error) {
      console.warn('Failed to add event listener:', error);
      return false;
    }
  }
  return false;
};

export const safeRemoveEventListener = (element, event, handler, options) => {
  if (element && typeof element.removeEventListener === 'function') {
    try {
      element.removeEventListener(event, handler, options);
      return true;
    } catch (error) {
      console.warn('Failed to remove event listener:', error);
      return false;
    }
  }
  return false;
};

// Filter out third-party extension errors from console
export const setupErrorFiltering = () => {
  // Override console.error to filter out extension errors
  const originalError = console.error;
  console.error = (...args) => {
    const message = args.join(' ');
    
    // Filter out known extension errors
    const extensionPatterns = [
      'share-modal.js',
      'content_script_bundle.js',
      'chrome-extension://',
      'moz-extension://',
      'safari-web-extension://',
      'edge-extension://',
      'TypeError: Cannot read properties of null'
    ];
    
    const isExtensionError = extensionPatterns.some(pattern => 
      message.includes(pattern)
    );
    
    if (!isExtensionError) {
      originalError.apply(console, args);
    }
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    
    // Filter out extension-related promise rejections
    if (error?.stack?.includes('extension://') || 
        error?.message?.includes('share-modal.js')) {
      event.preventDefault(); // Prevent logging
      return;
    }
    
    console.error('Unhandled promise rejection:', error);
  });

  // Handle general JavaScript errors
  window.addEventListener('error', (event) => {
    const { error, filename, message } = event;
    
    // Filter out extension errors
    if (filename?.includes('extension://') || 
        message?.includes('share-modal.js') ||
        error?.stack?.includes('extension://')) {
      event.preventDefault(); // Prevent logging
      return;
    }
  });
};